module.exports = __webpack_public_path__ + "static/media/infinity.247c0633.png";